import React from 'react';
import './contentunavaliable.css'

const ContentUnavailable = ({ reason, expiresAt }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'an unspecified time';
    
    return new Date(dateString).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
  };
  
  return (
    <div className="content-unavailable-container">
      <div className="content-unavailable-card">
        <div className="content-unavailable-icon">
          <i className="fa fa-exclamation-circle"></i>
        </div>
        <h2 className="content-unavailable-title">Content Temporarily Unavailable</h2>
        <div className="content-unavailable-message">
          This content has been hidden by moderators.
          {reason && <p className="content-unavailable-reason">{reason}</p>}
          {expiresAt && (
            <p className="content-unavailable-expiry">
              This content will be available again after {formatDate(expiresAt)}.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentUnavailable;